import React, { createContext, useState, useContext, useEffect } from 'react';
import { GetApproversList, GetManager, GetSponsorDetails } from '../services/user-service';
import { GetEmployeePass } from '../services/pass-service';
import { useUserContext } from './user/context';
import { Approver } from 'models/IApprover';
import { VisitorPass } from 'models/IVisitorPass';

const SponsorContext = createContext<any>(undefined);

export const Sponsor: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [sponsor, setSponsorDetails] = useState<any>();
  const userInfo = useUserContext();
  const [approvers, setApprovers] = useState<Approver[]>();
  const [manager, setManager] = useState<Approver>();
  const [fetched, setFetched] = useState(false);
  const [employeePass, setEmployeePass] = useState<VisitorPass | null>(null);
  const [tacDetails, setTacDetails] = useState<{
    tacTemplateName: string;
    enabletac: boolean;
  }>({
    tacTemplateName: '',
    enabletac: false,
  });

  useEffect(() => {
    const sponsorId = userInfo?.passplayUser?.sponsorId;
    if (sponsorId) {
      Promise.all([GetSponsorDetails(sponsorId), GetEmployeePass(sponsorId)])
        .then(([sponsorRes, employeePassRes]) => {
          setSponsorDetails(sponsorRes.data);
          setEmployeePass(employeePassRes.data || null);
        })
        .catch(() => {
          setEmployeePass(null);
        });
    }
  }, [userInfo?.passplayUser]);

  const fetchApproversAndManager = async () => {
    if (fetched) return;
    const [approvers, manager] = await Promise.all([GetApproversList(), GetManager()]);
    setApprovers(approvers);
    setManager(manager);
    setFetched(true);
  };

  return (
    <SponsorContext.Provider
      value={{
        sponsor,
        setSponsorDetails,
        approvers,
        setApprovers,
        manager,
        setManager,
        fetchApproversAndManager,
        tacDetails,
        setTacDetails,
        employeePass,
      }}
    >
      {children}
    </SponsorContext.Provider>
  );
};

export const useSponsorContext = () => {
  const context = useContext(SponsorContext);
  if (context === undefined) {
    throw new Error('useSponsorContext must be used within a SponsorProvider');
  }
  return context;
};
